module.exports = __webpack_public_path__ + "static/media/alycore05.c503f4f9.png";